import http from '@/requests/http'

class CallNote {
  static convert (params) {
    return http.post('call-note', params)
  }
}

export default CallNote
